import * as Sentry from "@sentry/react";
import packageJson from "../../../package.json";

let sentryInitialized = false;

export const initializeSentry = () => {
    if (sentryInitialized || process.env.NODE_ENV !== "production") return;

    Sentry.init({
        dsn: "https://2223ac139df8169e6df3962ce5051922@sentry2.pttp.me/8",
        release: `cashboxapp@${packageJson.version}`,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
            Sentry.captureConsoleIntegration({ levels: ["error"] }),
        ],
        enableLogs: true, // Enable logs to be sent to Sentry
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/, /^https:\/\/192.168.100.3/, /^https:\/\/cashbox.digiairmenu.com/],
        // Session Replay
        replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });

    sentryInitialized = true;
};
